import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kttkmvdusx: FaireBrandEntity = {
  token: "b_kttkmvdusx",
  type: "brand",
  name: "PennyLine",
  location: "Gilbert, AZ, USA",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
